import moment from 'moment';

import { LARGE_EQUIPMENT_CATEGORY, VEHICLE_CATEGORIES } from '../constants/categories';

export const timestampToIsoFormat = (timestamp) => {
  return moment.utc(timestamp).toISOString();
};

export const getDurationMessage = (start, end) => {
  // we don't use moment.js here to avoid miss calculations with months and weeks
  // since they can vary in length,
  // we count them in a fixed way of 28 days per month to match the Rental Rate Calculation logic
  const startDate = new Date(start);
  const endDate = new Date(end);

  // Calculate total difference in milliseconds
  const totalMilliseconds = endDate.getTime() - startDate.getTime();
  let totalMinutes = Math.floor(totalMilliseconds / (1000 * 60));

  // Define time units in minutes
  const MINUTES_IN_HOUR = 60;
  const MINUTES_IN_DAY = 24 * MINUTES_IN_HOUR;
  const MINUTES_IN_WEEK = 7 * MINUTES_IN_DAY;
  const MINUTES_IN_MONTH = 28 * MINUTES_IN_DAY;

  // Calculate each unit
  const months = Math.floor(totalMinutes / MINUTES_IN_MONTH);
  totalMinutes %= MINUTES_IN_MONTH;

  const weeks = Math.floor(totalMinutes / MINUTES_IN_WEEK);
  totalMinutes %= MINUTES_IN_WEEK;

  const days = Math.floor(totalMinutes / MINUTES_IN_DAY);
  totalMinutes %= MINUTES_IN_DAY;

  const hours = Math.floor(totalMinutes / MINUTES_IN_HOUR);
  const minutes = totalMinutes % MINUTES_IN_HOUR;

  let message = '';

  if (months > 0) {
    message += months > 1 ? `${months} months` : `${months} month`;
  }

  if (weeks > 0) {
    message += message !== '' ? ', ' : '';
    message += weeks > 1 ? `${weeks} weeks` : `${weeks} week`;
  }

  if (days > 0) {
    message += message !== '' ? ', ' : '';
    message += days > 1 ? `${days} days` : `${days} day`;
  }

  if (hours > 0) {
    message += message !== '' ? ', ' : '';
    message += hours > 1 ? `${hours} hours` : `${hours} hour`;
  }

  if (minutes > 0) {
    message += message !== '' ? ', ' : '';
    message += minutes > 1 ? `${minutes} minutes` : `${minutes} minute`;
  }

  return message;
};

export const vehicleCheck = (rentalCategory) => {
  return VEHICLE_CATEGORIES.includes(rentalCategory);
};

export const largeEquipmentCheck = (rentalCategory) => {
  return LARGE_EQUIPMENT_CATEGORY.includes(rentalCategory);
};
